"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nmr_processing_1 = require("nmr-processing");
const formatNumber_1 = require("../../../utility/formatNumber");
function SignalDeltaHzColumn({ row, onHover, format, info, rowSpanTags, }) {
    const signal = row.tableMetaInfo.signal;
    if (!signal)
        return (0, jsx_runtime_1.jsx)("td", { children: '' });
    return ((0, jsx_runtime_1.jsx)("td", { ...rowSpanTags, ...onHover, children: !(0, nmr_processing_1.checkMultiplicity)(signal.multiplicity, ['m'])
            ? `${(0, formatNumber_1.formatNumber)(row.from * info.originFrequency, format)} - ${(0, formatNumber_1.formatNumber)(row.to * info.originFrequency, format)}`
            : info?.originFrequency
                ? (0, formatNumber_1.formatNumber)(signal.delta * info.originFrequency, format)
                : '' }));
}
exports.default = SignalDeltaHzColumn;
